export default __webpack_public_path__ + "static/media/HP-Guide–Assessment Retake.65bef4d3.pdf";